var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"mr-3 btn branches_btn",on:{"click":function($event){return _vm.downloadPdf(_vm.data.id)}}},[_vm._v("\n    "+_vm._s(_vm.$t('text.clickButtons.download'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }